(function ($) {
    $(function () {
        $('.placeholder-wrapper').on('click', function () {
            const $placeholder   = $(this);
            const $videoInline   = $placeholder.closest('.video-inline');
            const $iframeWrapper = $videoInline.find('.iframe-wrapper');

            $placeholder.addClass('d-none');
            $iframeWrapper.removeClass('d-none');

            // Only play the visible (desktop OR mobile) video for this block
            $iframeWrapper.find('video.video-element:visible').each(function () {
                const p = this.play();
                if (p !== undefined) p.catch(() => {}); // swallow interrupted-play noise
            });
        });
    });
})(jQuery);
